import { useEffect, useState } from 'react';

import { GridContainer, Loader2, Error } from 'libs/ui';
import { Container } from 'libs/form';
import { getClientsOpt } from 'services/options-service';
// import { ClientsOpt } from 'grids/clients-opt/clients-opt';
import { ClientsOptFullForm } from './forms/clients-opt-full-form';

export const ClientsOptWrapper = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!data) {
      getClientsOpt()
        .then((result) => {
          // console.log('data', data);
          if (result.items?.length === 3) {
            const item = result.items[0];

            const out = {
              is_active: item.is_active,
              update_day: item.update_day,
              update_amount: {},
            };
            result.items.forEach((el) => {
              out.update_amount[el.client_type] = el.update_amount / 100;
            });

            setData(out);
          } else {
            setError('Неверный формат входных данных');
          }
        })
        .catch((error) => {
          setError(error.toString());
        });
    }
  }, []);

  if (error) {
    return <Error>{error}</Error>;
  }

  if (!data) {
    return <Loader2 height="140px" />;
  }
  // console.log('data', data);
  return (
    <GridContainer>
      {/* <ClientsOpt {...props} /> */}
      <Container className="hide-cal-icon cp-round">
        <ClientsOptFullForm initialValues={data} />
      </Container>
    </GridContainer>
  );
};
